module.exports = __webpack_public_path__ + "static/media/garage laundry storage 1.79f1d353.jpeg";